import _ from 'underscore';
import { useContext, useEffect, useState } from 'react';

import { ScopeContext } from '@bingads-webui-react/scope-service';
import { edmCampaign } from '@bingads-webui/edm-campaign';

import { formatDate } from '../utils/format-date';
import { Asset, IScopeContext } from '../utils/types';
import { AssetType } from '../filter/const';

function filterByAssetType(assets, assetType) {
  if (assetType === AssetType.All) {
    return assets;
  }
  if (assetType === AssetType.Logo) {
    return assets.filter(asset => asset.AssociationType === 'SquareLogoMedia');
  }
  if (assetType === AssetType.Image) {
    return assets.filter(asset => asset.Asset.AssetType === 'Image' && asset.AssociationType !== 'SquareLogoMedia');
  }
  if (assetType === AssetType.LongHeadline) {
    return assets.filter(asset => asset.AssociationType === 'LongHeadlines');
  }
  if (assetType === AssetType.ShortHeadline) {
    return assets.filter(asset => asset.AssociationType === 'Headlines');
  }
  if (assetType === AssetType.Description) {
    return assets.filter(asset => asset.AssociationType === 'Descriptions');
  }
  if (assetType === AssetType.CallToAction) {
    return assets.filter(asset => asset.AssociationType === 'CallToAction');
  }
  if (assetType === AssetType.Video) {
    return assets.filter(asset => asset.AssociationType === 'VideoMedia16X9');
  }

  return assets;
}

export const useFilteredAssetData = (headerState, dateRange) => {
  const { scope } = useContext(ScopeContext) as IScopeContext;
  const {
    values: {
      cid,
      aid,
      campaignId,
    },
  } = scope;

  const [assets, setAssets] = useState<Array<Asset>>();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (_.isNumber(headerState?.assetContainer?.Id)) {
      setIsLoading(true);
      edmCampaign
        .Customers.$withKey(cid)
        .Accounts.$withKey(aid)
        .Campaigns.$withKey(campaignId)
        .AssetGroups.$withKey(headerState?.assetContainer?.Id)['Default.GetAssetLinks']
        .$makeCall({
          query: {
            skip: 0,
            top: 50,
            filter: { where: 'Asset/AssetSource eq Enum.AssetSource\'AdvertiserProvided\'' },
          },
          payload: {
            gridDataParameters: {
              DateRange: {
                StartDate: formatDate(dateRange.start),
                EndDate: formatDate(dateRange.end),
              },
            },
          },
        })
        .subscribe({
          next: (data) => {
            setAssets(filterByAssetType(data?.value, headerState?.assetType));
            setIsLoading(false);
          },
        });
    } else if (!_.isEmpty(headerState)) {
      setAssets(undefined);
      setIsLoading(false);
    }
  }, [aid, campaignId, cid, headerState, dateRange]);

  return { isLoading, assets };
};
